






















































import Vue, {VueConstructor} from 'vue'
import _ from 'lodash'

import ActiveForm, {ActiveFormOptions} from './BZCore/ActiveForm'

import Steps from './Steps.vue'
import FormFooter from './Footer.vue'

interface ActiveFieldComponentInterface {
  reset: () => void
}

export default (Vue as VueConstructor<Vue & {
  $refs: {
    fields: ActiveFieldComponentInterface[],
  }
}>).extend({
  name: 'ActiveForm',
  components: {Steps, FormFooter},
  props: {
    value: {
      type: Object as () => any,
      required: true,
      default: () => {
        return {}
      }
    },
    form: Object as () => ActiveFormOptions,
    scope: {
      type: Object as () => any,
      default: () => {
        return {}
      }
    },
    submitBtn: {type: Boolean as () => boolean, default: true},
    small: {type: Boolean as () => boolean, default: false},
    cancel: {type: Boolean as () => boolean, default: false}
  },
  data () {
    return {
      activeForm: new ActiveForm(this.form, this.value, this.scope)
    }
  },
  watch: {
    stepDisabled () {
      if (this.stepDisabled) {
        this.nextStep()
      }
    },
    form () {
      console.error('Don`t change form options on mounted form! The consequences are unpredictable')
    },
    'activeForm.step' () {
      this.$emit('step', this.activeForm.step)
    },
    value () {
      Vue.set(this.activeForm, 'data', this.value)
    },
    scope () {
      Vue.set(this.activeForm, 'scope', this.scope)
    }
  },
  computed: {
    step (): number {
      return this.activeForm.step
    },
    stepDisabled (): boolean {
      return this.activeForm.stepDisabled(this.activeForm.step)
    },
    formScope (): any {
      return {
        component: this,
        activeForm: this.activeForm
      }
    },
    stepMap (): string[][] {
      return this.activeForm.getStepMap(this.activeForm.step)
    },
    submitText (): string {
      // @ts-ignore
      return this.activeForm.form.submitText || this.$t('labels.create')
    }
  },
  methods: {
    reset () {
      for (const field of this.$refs.fields) {
        field.reset()
      }
    },
    emitCancel () {
      this.$emit('cancel')
    },
    onInput (col: string, value: any) {
      let newValue = _.cloneDeep(this.activeForm.data)
      this.$set(newValue, col, value)
      this.$emit('input', newValue)
      this.$nextTick(() => {
        if (this.activeForm!.fields[col]) {
          this.activeForm!.fields[col].validate(newValue[col])
        }
      })
    },
    onError (event: any): void {
      this.$emit('error', event)
    },
    async nextStep () {
      if (!(await this.activeForm.nextStep())) {
        this.onSubmit()
      }
    },
    async prevStep () {
      await this.activeForm.prevStep()
    },
    async validation (submit = false) {
      await this.activeForm.validate(submit)
    },
    async onSubmit () {
      try {
        await this.activeForm.validate(true)

        if (this.activeForm.errors.length > 0) {
          console.log('form errors', this.activeForm.errors)
        } else {
          this.$emit('submit', this.activeForm.data)

          if (this.form.onSubmit) {
            const item = await this.form.onSubmit.apply(this.activeForm, [this.activeForm.data])
            this.$emit('created', item)
          }
        }
      } catch (error) {
        console.error(error)
        this.$emit('error')
      }
    }
  }
})
